import { useState, useEffect } from 'react';

const useFetchData = (section, title) => {
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(
          `/api/questions/${section}/${title}`,
             {
            method: 'GET',
            credentials: 'include', // Ensures cookies are included in the request
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch post");
        }
        const data = await response.json();
        setPost(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPost();
  }, [section, title]);

  return post;
};

export default useFetchData;
